import { NoteDto } from "../../dtos/NoteDto";
import { NoteRequest } from "../../dtos/NoteRequest";
import { NoteTargetDto } from "../../dtos/NoteTargetDto";
import { UserRole } from "../../dtos/UserRole";
import { ApiResult, apiWrapperWithError } from "./ApiUtils";

export const getGrantNotes = async (grantId: string): Promise<ApiResult<NoteDto[]> | null> => {
    return apiWrapperWithError<NoteDto[]>(`api/notes/grant/${grantId}`, 'GET', `fetching notes for grant ${grantId}`);
};

// The audience roles the current user can stamp a new note with on this grant. The dialog only shows
// a picker when there is more than one.
export const getNoteAudienceRoles = async (grantId: string): Promise<ApiResult<UserRole[]> | null> => {
    return apiWrapperWithError<UserRole[]>(`api/notes/grant/${grantId}/audience-roles`, 'GET', `fetching note audience roles for grant ${grantId}`);
};

// Flat module → task → subtask targets for the note tree selector. Unfiltered (matches the
// progress monitor, unlike the permission-filtered phase list used elsewhere).
export const getNoteTargets = async (grantId: string): Promise<ApiResult<NoteTargetDto[]> | null> => {
    return apiWrapperWithError<NoteTargetDto[]>(`api/notes/grant/${grantId}/targets`, 'GET', `fetching note targets for grant ${grantId}`);
};

export const createNote = async (grantId: string, note: NoteRequest): Promise<ApiResult<NoteDto> | null> => {
    return apiWrapperWithError<NoteDto>(`api/notes/grant/${grantId}`, 'POST', `creating note for grant ${grantId}`, note);
};

export const updateNote = async (noteId: string, note: NoteRequest): Promise<ApiResult<NoteDto> | null> => {
    return apiWrapperWithError<NoteDto>(`api/notes/${noteId}`, 'PUT', `updating note ${noteId}`, note);
};

export const deleteNote = async (noteId: string): Promise<ApiResult<boolean> | null> => {
    return apiWrapperWithError<boolean>(`api/notes/${noteId}`, 'DELETE', `deleting note ${noteId}`);
};
